import { render, staticRenderFns } from "./configOptionalRole.vue?vue&type=template&id=3c2b6d40&scoped=true"
import script from "./configOptionalRole.vue?vue&type=script&lang=js"
export * from "./configOptionalRole.vue?vue&type=script&lang=js"
import style0 from "./configOptionalRole.vue?vue&type=style&index=0&id=3c2b6d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2b6d40",
  null
  
)

export default component.exports